/**
 * TreeMapBreadcrumbs Component
 *
 * Navigation breadcrumbs for drill-down views
 */

import React from 'react';
import type { TreeMapBreadcrumbsProps } from '../../organisms/TreeMap/types';
import './TreeMapBreadcrumbs.scss';

const TreeMapBreadcrumbs: React.FC<TreeMapBreadcrumbsProps> = ({
  breadcrumbs,
  onNavigate,
  maxItems = 5,
}) => {
  return (
    <nav className="tree-map-breadcrumbs" aria-label="Breadcrumb">
      <ol className="tree-map-breadcrumbs__list">
        {/* Home */}
        <li className="tree-map-breadcrumbs__item">
          <button
            className="tree-map-breadcrumbs__link"
            onClick={() => onNavigate({ label: 'Home' }, -1)}
            title="Return to root view"
          >
            <i className="pi pi-home" />
          </button>
        </li>

        {/* Breadcrumb items */}
        {breadcrumbs.map((item, index) => (
          <React.Fragment key={item.sphereId ?? `breadcrumb-${item.label}-${index}`}>
            <li className="tree-map-breadcrumbs__separator" aria-hidden="true">
              <i className="pi pi-angle-right" />
            </li>
            <li className="tree-map-breadcrumbs__item">
              {index === breadcrumbs.length - 1 ? (
                <span className="tree-map-breadcrumbs__current">
                  {item.icon && <span className="tree-map-breadcrumbs__icon">{item.icon}</span>}
                  {item.label}
                </span>
              ) : (
                <button
                  className="tree-map-breadcrumbs__link"
                  onClick={() => onNavigate(item, index)}
                  title={`Navigate to ${item.label}`}
                >
                  {item.icon && <span className="tree-map-breadcrumbs__icon">{item.icon}</span>}
                  {item.label}
                </button>
              )}
            </li>
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default TreeMapBreadcrumbs;
